<script setup lang="ts">
withDefaults(defineProps<{
    size?: number | string;
    strokeWidth?: number | string;
}>(), {
    size: 16,
    strokeWidth: 1.8
});
</script>

<template>
    <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor" :stroke-width="strokeWidth" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="6" r="3" />
        <path d="M7 21v-3a5 5 0 0 1 10 0v3" />
        <path d="M5 6.5a2.5 2.5 0 1 0 0 5M19 6.5a2.5 2.5 0 1 1 0 5" />
        <path d="M3.5 15A3.5 3.5 0 0 0 1 18.35V20h3M20.5 15a3.5 3.5 0 0 1 2.5 3.35V20h-3" />
    </svg>
</template>
